import { useGetAllRoutesFromState } from 'utils/hooks/useGetAllRoutes';

export const useAllRoutesMapItems = () => {
  const { notHiddenRoutes } = useGetAllRoutesFromState();

  const onFieldClick = ({
    fieldSeasonId,
    routeId,
  }: {
    fieldSeasonId?: number;
    routeId?: number;
  }) => {
    console.log('clicked on field');
  };

  return {
    routes: notHiddenRoutes,
    onFieldClick,
  };
};
